import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ReferenceDataConstants } from '../../lib/constants/reference-data-constants';

@Injectable({
  providedIn: 'root'
})
export class ApplicationHostTypeService {
  private static readonly PropositionInterfaceCssClasses = [
    {
      code: 'boi',
      cssClasses: ['boi']
    },
    {
      code: 'po',
      cssClasses: ['po']
    },
    {
      code: 'op',
      cssClasses: ['boi', 'direct']
    },
    {
      code: 'boid',
      cssClasses: ['boi', 'direct']
    },
    {
      code: 'pod',
      cssClasses: ['po', 'direct']
    },
    {
      code: 'aad',
      cssClasses: ['aa', 'direct']
    }
  ];

  private code: string;
  private interfaceType: number;

  constructor(@Inject(DOCUMENT) private readonly _document) {}

  public updateCode(): void {
    this.code = window.location.pathname.split('/')[2]?.toLowerCase();
  }

  public updateFavicon(): void {
    this._document.getElementById('appFavicon').setAttribute('href', `assets/${this.code}-favicon.ico`);
  }

  public setInterfaceType(value: number): void {
    this.interfaceType = value;
  }

  public getInterfaceType(): number {
    return this.interfaceType;
  }

  public getCode(): string {
    return this.code;
  }

  public getPropositionInterfaceCssClasses(): Array<string> {
    const propositionInterfaceCss = ApplicationHostTypeService.PropositionInterfaceCssClasses.find(
      (item) => item.code === this.code
    );

    return propositionInterfaceCss ? propositionInterfaceCss.cssClasses : [];
  }

  public isBrokerInterfaceType(): boolean {
    return this.getInterfaceType() === ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID;
  }

  public isDirectInterfaceType(): boolean {
    return this.getInterfaceType() === ReferenceDataConstants.DIRECT_INTERFACE_TYPE_ID;
  }
}
